/**
 * TrustBar — hardcoded trust / USP items (TSS-535)
 *
 * Single source of truth for the homepage trust strip. Previously lived in
 * Footer (utilityLinksConfig); moved here when the footer strip was removed and
 * these badges became homepage-only. Each item carries its own `Icon`
 * (fill-current SVG), so the bar needs no separate icon import.
 */
import {
  CreditCardIcon,
  InfoIcon,
  CertificateIcon,
  TruckIcon,
  UndoIcon,
} from './icons'

import type { ReactElement } from 'react'


export interface TrustItem {
  id: string
  Icon: () => ReactElement
  text: string
  href: string
  nofollow?: boolean
}

/** CMS anchor for the TBI "Plată în rate" card — set in PageBuilder. Shared target
 *  with the product-page TBI card (Catalog `TBI_INSTALLMENTS_URL`). */
export const TBI_CARD_HREF = '/cum-cumpar.html#rate-tbi'

/** CMS anchor for the reward-points card — set in PageBuilder. */
export const REWARD_POINTS_HREF = '/termeni-si-conditii#puncte-bonus'

export const trustItems: TrustItem[] = [
  {
    id: 'cumparaturi_sigure',
    Icon: CreditCardIcon,
    text: 'Cumparaturi 100% sigure',
    href: '/avantaje-cumparaturi-online#cumparaturi-sigure',
    nofollow: true,
  },
  {
    id: 'suport_specializat',
    Icon: InfoIcon,
    text: 'Suport specializat',
    href: '/avantaje-cumparaturi-online#suport-specializat',
  },
  {
    id: 'garantie_service',
    Icon: CertificateIcon,
    text: 'Garantie & service',
    href: '/avantaje-cumparaturi-online#returnare',
  },
  {
    id: 'transport_gratuit',
    Icon: TruckIcon,
    text: 'Transport gratuit',
    href: '/avantaje-cumparaturi-online#transport-gratuit',
  },
  {
    id: 'retur_produse',
    Icon: UndoIcon,
    text: 'Retur produse',
    href: '/avantaje-cumparaturi-online#returnare',
  },
]
